import React from "react";
import Marquee from "react-fast-marquee";

// ── Inline SVG icons per industry ──────────────────────────────────────────

const IconFintech = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" width="32" height="32">
    <circle cx="24" cy="24" r="20" fill="url(#ig1)"/>
    <path d="M24 13v2m0 18v2m-7-11h2m10 0h2" stroke="#fff" strokeWidth="1.8" strokeLinecap="round"/>
    <circle cx="24" cy="24" r="6" stroke="#fff" strokeWidth="1.8"/>
    <path d="M19 19l-3-3m13 0-3 3m0 10 3 3m-13 0 3-3" stroke="rgba(255,255,255,0.6)" strokeWidth="1.4" strokeLinecap="round"/>
    <defs>
      <linearGradient id="ig1" x1="4" y1="4" x2="44" y2="44" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00c896"/><stop offset="1" stopColor="#0ea5e9"/>
      </linearGradient>
    </defs>
  </svg>
);

const IconBanking = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" width="32" height="32">
    <circle cx="24" cy="24" r="20" fill="url(#ig2)"/>
    <path d="M12 20h24M24 12l12 8H12l12-8z" fill="rgba(255,255,255,0.25)" stroke="#fff" strokeWidth="1.6" strokeLinejoin="round"/>
    <rect x="15" y="20" width="3" height="12" rx="1" fill="#fff"/>
    <rect x="22.5" y="20" width="3" height="12" rx="1" fill="#fff"/>
    <rect x="30" y="20" width="3" height="12" rx="1" fill="#fff"/>
    <rect x="12" y="32" width="24" height="2.5" rx="1" fill="#fff"/>
    <defs>
      <linearGradient id="ig2" x1="4" y1="4" x2="44" y2="44" gradientUnits="userSpaceOnUse">
        <stop stopColor="#6366f1"/><stop offset="1" stopColor="#a855f7"/>
      </linearGradient>
    </defs>
  </svg>
);

const IconTelco = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" width="32" height="32">
    <circle cx="24" cy="24" r="20" fill="url(#ig3)"/>
    <rect x="17" y="14" width="14" height="20" rx="3" stroke="#fff" strokeWidth="1.6"/>
    <rect x="20" y="30" width="8" height="1.5" rx="0.75" fill="#fff"/>
    <circle cx="24" cy="18" r="1.5" fill="#fff"/>
    <path d="M28 22h2.5M17.5 22H20" stroke="rgba(255,255,255,0.5)" strokeWidth="1.2" strokeLinecap="round"/>
    <defs>
      <linearGradient id="ig3" x1="4" y1="4" x2="44" y2="44" gradientUnits="userSpaceOnUse">
        <stop stopColor="#f59e0b"/><stop offset="1" stopColor="#ef4444"/>
      </linearGradient>
    </defs>
  </svg>
);

const IconHealthcare = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" width="32" height="32">
    <circle cx="24" cy="24" r="20" fill="url(#ig4)"/>
    <path d="M24 14c-5 0-9 4-9 9 0 7 9 13 9 13s9-6 9-13c0-5-4-9-9-9z" fill="rgba(255,255,255,0.2)" stroke="#fff" strokeWidth="1.6" strokeLinejoin="round"/>
    <path d="M21 24h6M24 21v6" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
    <defs>
      <linearGradient id="ig4" x1="4" y1="4" x2="44" y2="44" gradientUnits="userSpaceOnUse">
        <stop stopColor="#ec4899"/><stop offset="1" stopColor="#f43f5e"/>
      </linearGradient>
    </defs>
  </svg>
);

const IconEcommerce = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" width="32" height="32">
    <circle cx="24" cy="24" r="20" fill="url(#ig5)"/>
    <path d="M13 15h3l2.5 12h13l2.5-9H18" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="21" cy="31" r="2" fill="#fff"/>
    <circle cx="31" cy="31" r="2" fill="#fff"/>
    <defs>
      <linearGradient id="ig5" x1="4" y1="4" x2="44" y2="44" gradientUnits="userSpaceOnUse">
        <stop stopColor="#10b981"/><stop offset="1" stopColor="#059669"/>
      </linearGradient>
    </defs>
  </svg>
);

const IconGovernment = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" width="32" height="32">
    <circle cx="24" cy="24" r="20" fill="url(#ig6)"/>
    <path d="M24 12l13 6H11l13-6z" fill="rgba(255,255,255,0.25)" stroke="#fff" strokeWidth="1.5" strokeLinejoin="round"/>
    <rect x="14" y="20" width="3.5" height="10" rx="1" fill="#fff"/>
    <rect x="22.25" y="20" width="3.5" height="10" rx="1" fill="#fff"/>
    <rect x="30.5" y="20" width="3.5" height="10" rx="1" fill="#fff"/>
    <rect x="11" y="30" width="26" height="3" rx="1.5" fill="#fff"/>
    <defs>
      <linearGradient id="ig6" x1="4" y1="4" x2="44" y2="44" gradientUnits="userSpaceOnUse">
        <stop stopColor="#3b82f6"/><stop offset="1" stopColor="#1d4ed8"/>
      </linearGradient>
    </defs>
  </svg>
);

const IconCrypto = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" width="32" height="32">
    <circle cx="24" cy="24" r="20" fill="url(#ig7)"/>
    <path d="M16 20h8c2 0 3.5 1 3.5 3s-1.5 3-3.5 3h-8v-6z" stroke="#fff" strokeWidth="1.5" strokeLinejoin="round"/>
    <path d="M16 26h9c2.5 0 4 1 4 3.5S27.5 33 25 33h-9v-7z" stroke="#fff" strokeWidth="1.5" strokeLinejoin="round"/>
    <path d="M21 20v-2m0 17v-2m3-15v-2m0 17v-2" stroke="rgba(255,255,255,0.6)" strokeWidth="1.3" strokeLinecap="round"/>
    <defs>
      <linearGradient id="ig7" x1="4" y1="4" x2="44" y2="44" gradientUnits="userSpaceOnUse">
        <stop stopColor="#f97316"/><stop offset="1" stopColor="#eab308"/>
      </linearGradient>
    </defs>
  </svg>
);

const IconInsurance = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" width="32" height="32">
    <circle cx="24" cy="24" r="20" fill="url(#ig8)"/>
    <path d="M24 13L14 17.5v8c0 5.5 4.3 10.7 10 12 5.7-1.3 10-6.5 10-12v-8L24 13z"
      fill="rgba(255,255,255,0.15)" stroke="#fff" strokeWidth="1.6" strokeLinejoin="round"/>
    <path d="M20 24l3 3 5-5" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <defs>
      <linearGradient id="ig8" x1="4" y1="4" x2="44" y2="44" gradientUnits="userSpaceOnUse">
        <stop stopColor="#8b5cf6"/><stop offset="1" stopColor="#6366f1"/>
      </linearGradient>
    </defs>
  </svg>
);

const IconLogistics = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" width="32" height="32">
    <circle cx="24" cy="24" r="20" fill="url(#ig9)"/>
    <rect x="11" y="19" width="18" height="12" rx="2" stroke="#fff" strokeWidth="1.5"/>
    <path d="M29 22h4l4 5v4h-8V22z" stroke="#fff" strokeWidth="1.5" strokeLinejoin="round"/>
    <circle cx="16" cy="33" r="2.5" fill="#fff"/>
    <circle cx="33" cy="33" r="2.5" fill="#fff"/>
    <defs>
      <linearGradient id="ig9" x1="4" y1="4" x2="44" y2="44" gradientUnits="userSpaceOnUse">
        <stop stopColor="#06b6d4"/><stop offset="1" stopColor="#0ea5e9"/>
      </linearGradient>
    </defs>
  </svg>
);

// ── Industry data ────────────────────────────────────────────────────────────

const industries = [
  { icon: <IconFintech />,    title: "Fintech & Lending",    color: "#00c896" },
  { icon: <IconBanking />,    title: "Banking",               color: "#6366f1" },
  { icon: <IconTelco />,      title: "Telco & Marketplace",   color: "#f59e0b" },
  { icon: <IconHealthcare />, title: "Healthcare",            color: "#ec4899" },
  { icon: <IconEcommerce />,  title: "E-commerce",            color: "#10b981" },
  { icon: <IconGovernment />, title: "Government",            color: "#3b82f6" },
  { icon: <IconCrypto />,     title: "Crypto & Web3",         color: "#f97316" },
  { icon: <IconInsurance />,  title: "Insurance",             color: "#8b5cf6" },
  { icon: <IconLogistics />,  title: "Logistics",             color: "#06b6d4" },
];

const IndustryCard: React.FC<{ icon: React.ReactNode; title: string; color: string }> = ({ icon, title, color }) => (
  <div style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "14px",
    padding: "24px 20px",
    background: "#ffffff",
    borderRadius: "20px",
    border: "1px solid rgba(15,32,64,0.07)",
    boxShadow: "0 4px 24px rgba(15,32,64,0.06)",
    minWidth: "148px",
    margin: "0 10px",
    transition: "transform 0.25s, box-shadow 0.25s",
    cursor: "default",
  }}
    onMouseEnter={e => {
      (e.currentTarget as HTMLDivElement).style.transform = "translateY(-4px)";
      (e.currentTarget as HTMLDivElement).style.boxShadow = `0 12px 32px rgba(15,32,64,0.10), 0 0 0 1px ${color}33`;
    }}
    onMouseLeave={e => {
      (e.currentTarget as HTMLDivElement).style.transform = "translateY(0)";
      (e.currentTarget as HTMLDivElement).style.boxShadow = "0 4px 24px rgba(15,32,64,0.06)";
    }}
  >
    {/* Icon circle */}
    <div style={{
      width: "68px",
      height: "68px",
      borderRadius: "50%",
      background: `${color}12`,
      border: `1.5px solid ${color}33`,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}>
      {icon}
    </div>

    {/* Label */}
    <span style={{
      fontSize: "13px",
      fontWeight: 600,
      color: "#0f2040",
      textAlign: "center",
      lineHeight: "1.3",
      whiteSpace: "nowrap",
    }}>
      {title}
    </span>

    {/* Color accent line */}
    <div style={{
      width: "24px",
      height: "2px",
      borderRadius: "2px",
      background: color,
      opacity: 0.6,
    }} />
  </div>
);

// ── Main Section ─────────────────────────────────────────────────────────────

const IndustriesSection: React.FC = () => {
  const row1 = industries.slice(0, 5);
  const row2 = industries.slice(4);   // slight overlap for natural feel

  return (
    <section
      className="industries pb-140"
      style={{
        background: "linear-gradient(180deg, #f0faf6 0%, #eef6ff 60%, #f8fafc 100%)",
        overflow: "hidden",
        paddingTop: "100px",
      }}
    >
      {/* Heading */}
      <div className="container" style={{ marginBottom: "60px" }}>
        <div className="sec-title sec-title-center text-center">
          <span className="sub-title mb-15">Industries Served</span>
          <h2 className="title">
            Trusted across every regulated industry
          </h2>
          <p style={{
            color: "rgba(15,32,64,0.55)",
            maxWidth: "520px",
            margin: "16px auto 0",
            fontSize: "16px",
            lineHeight: "1.7",
          }}>
            From fintech to healthcare — TrustEngine powers compliant identity
            verification across every regulated sector.
          </p>
        </div>
      </div>

      {/* Row 1 — scrolls right */}
      <div style={{ marginBottom: "16px" }}>
        <Marquee direction="right" speed={38} gradient={false} pauseOnHover>
          <div style={{ display: "flex", alignItems: "stretch", padding: "8px 0" }}>
            {[...row1, ...row1, ...row1].map((item, i) => (
              <IndustryCard key={i} icon={item.icon} title={item.title} color={item.color} />
            ))}
          </div>
        </Marquee>
      </div>

      {/* Row 2 — scrolls left */}
      <div>
        <Marquee direction="left" speed={30} gradient={false} pauseOnHover>
          <div style={{ display: "flex", alignItems: "stretch", padding: "8px 0" }}>
            {[...row2, ...row2, ...row2].map((item, i) => (
              <IndustryCard key={i} icon={item.icon} title={item.title} color={item.color} />
            ))}
          </div>
        </Marquee>
      </div>

      {/* Bottom stat strip */}
      <div className="container" style={{ marginTop: "60px" }}>
        <div style={{
          display: "flex",
          justifyContent: "center",
          gap: "60px",
          flexWrap: "wrap",
        }}>
          {[
            { val: "9+",    label: "Industries covered" },
            { val: "50+",   label: "Enterprise clients" },
            { val: "99.9%", label: "Uptime SLA" },
          ].map((s, i) => (
            <div key={i} style={{ textAlign: "center" }}>
              <div style={{
                fontSize: "32px",
                fontWeight: 800,
                color: "#00c896",
                lineHeight: "1",
              }}>
                {s.val}
              </div>
              <div style={{
                fontSize: "13px",
                color: "rgba(15,32,64,0.5)",
                marginTop: "6px",
                fontWeight: 500,
              }}>
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
